(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7278],{

/***/ 73741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/kidizen-photo-tips/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-06-14",
      tag: "Kidizen",
      title: "Make Your Listings Effective With These Kidizen Photo Tips",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Importance of an effective photo for a listing"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The importance of taking an effective photo to add to your listings is due to the fact that people are inherently visual buyers and would pass over a listing without at least one photo. So, quality listing images are required to make a positive first impression in today's buyer's market."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Always consider that online shoppers cannot touch and feel your product as they would in a physical store. So to sell an item and avoid costly returns, images must be of excellent quality, in high-resolution, taken from various angles, and in various colors, styles, and other variations.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Another good thing to note when creating your listings is that you can share photos so potential buyers can refer other potential customers to purchase with your store."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Tips on how to take eye-catching photos"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "One of the best ways to catch the attention of potential buyers is to take stunning pictures. This is the first thing that anyone sees when it comes to listings, so you should take your photos with these top tips in mind:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Always use a consistent and neutral background. Don't constantly change backgrounds because it can contrast with the subject and be seen as messy instead of neat from the buyer's perspective."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Take images in bright, natural light, and use editing tools to subtly enhance them. Don't go overboard that the picture becomes distorted or covers up the actual details (such as the flaws and whatnot) of the listing. People want to see everything if possible so keep a steady hand when it comes to editing."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Choose the correct photos because not every photo should be in the listing. "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "A good backdrop is essential. Take your photos in a clutter-free space to focus your buyer's attention on the item."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Angles that sellers should include in the photo"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "As mentioned above, buyers want to see clear and neat images that display the item's condition. Since they can't touch or inspect those items, a picture is worth a thousand words, especially when landing a sale."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "So when choosing the angles for your photos, be sure to experiment and take part shots showing each side/part of the item. If you want to show additional angles, you should include shots wherein the buyers can see the product in use, screenshots, accessories, or product details that display the item's condition."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Provide detailed descriptions using close-up images"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Sellers should always be clear and as accurate as possible when supporting their images with detailed descriptions to further narrate the item's condition and features to the potential buyer.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "For example, when taking a picture of an item's flaws, be sure to take clear close-up shots, point out the flaws, and mention any details that the buyer should know so they can make a proper decision about the purchase. This helps promote a good rapport as a seller and avoid future issues from the buyer's side."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Make your listings better with automation"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Every seller knows it takes considerable time and effort to create a compelling listing. And you'll always want to ensure your shop is still active when you're busy taking good-quality images, researching the details and background of your item, producing the listing description, and setting the proper pricing. You can achieve effective listings and optimize your store's performance by using OneShop as an automation tool that allows you to focus on crafting a great listing while saving time to focus on the big things."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Allowing you to easily cross-list across different marketplaces like Poshmark, Mercari, Depop, Tradesy, eBay, and more coming soon. You can also order shipping supplies for your business and schedule package pickups through the app for a more convenient way of shipping out your sold items. This and more features await you, so try it now by ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://tools.oneshop.com/signup",
          children: "signing up"
        }), " to set up your account in less than three minutes and enjoy a 7-day free trial!"]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/kidizen-photo-tips.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Make Your Listings Effective With These Kidizen Photo Tips"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Don't miss a beat when it comes to ensuring that your listings are as effective to catch any buyer's attention! Learn how to make them great with these Kidizen photo tips that will make your photos stand out from your competition."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/kidizen-photo-tips"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/kidizen-photo-tips"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Make Your Listings Effective With These Kidizen Photo Tips"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Don't miss a beat when it comes to ensuring that your listings are as effective to catch any buyer's attention! Learn how to make them great with these Kidizen photo tips that will make your photos stand out from your competition."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=3"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2022-06-14T00:00:00-00:00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2022-06-14T00:00:00-00:00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Kidizen"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 80728:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/kidizen-photo-tips",
      function () {
        return __webpack_require__(73741);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(80728); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);